import { datePipe, titleCasePipe } from "shared/pipes";

const tooltipMap = (boxStatus) => {
    const status = boxStatus?.toLowerCase();
    switch (status) {
        // case 'late':
        // return 'declared_late';
        case 'partially_returned':
            return 'declared_partially_returned';
        case 'returned':
            return 'declared_returned';
        default:
            return null;
    }
}

const statusMap = (boxStatus) => {
    const status = boxStatus?.toLowerCase();
    switch (status) {
        case 'at_customer':
            return 'is-dark';
        case 'late':
            return 'is-danger';
        case 'partially_returned':
            return 'is-warning';
        case 'returned':
            return 'is-success';
        case 'not_picked_up':
            return 'is-info';
        default:
            return 'is-white';
    }
}

const BoxStatusTag = ({ box, className = '' }) => {
    const status = box?.status || 'No Status';
    const statusColor = statusMap(status);

    return (
        <span className={`tag is-uppercase ${statusColor} ${className}`}>
            {titleCasePipe.transform(status)}
        </span>
    );
}

const BoxStatusTagWrapper = ({ box, className = '' }) => {
    const tooltip = () => {
        const field = tooltipMap(box.status);
        return box && field ? datePipe.transform(box[field], true) : null;
    }

    return (
        <div data-tooltip={tooltip()}>
            <BoxStatusTag box={box} className={className} />
        </div>
    );
}

export { BoxStatusTagWrapper as BoxStatusTag };
